import { useEffect } from "react";
import "./components/style/main.scss";
import FloatingActionTrigger from "./components/molecules/FloatingActionTrigger.jsx";
import FloatingWindow from "./components/organisms/FloatingWindow.jsx";
// import {
//     INTERNAL_PARAM,
//     QUERY_PARAMS,
//     ALLOWED_HOSTNAME,
// } from "../constants.js";
import { operationHour } from "./services/apiService.js";
import { useDispatch } from "react-redux";
import { setFloatingContainerState } from "./features/componentStateSlice.js";

export function App() {
    const host = document.getElementById("app");
    const shadowRoot = host.shadowRoot;
    const dispatch = useDispatch();

    // Insert styling
    // useEffect(() => {
    //     const taxlabStyling = document.createElement("style");
    //     taxlabStyling.setAttribute("type", "text/css");
    //     taxlabStyling.textContent = styling;
    //     shadowRoot.appendChild(taxlabStyling);
    // }, [shadowRoot]);

    // Check Operation Hour
    useEffect(async () => {
      // dispatch(setFloatingContainerState(true));
        // if (ALLOWED_HOSTNAME.includes(window.location.hostname)) {
        //     if (!QUERY_PARAMS.includes(INTERNAL_PARAM)) {
        //         const operationResponse = await operationHour();
        //         if (operationResponse.is_service === true)
        //             dispatch(setFloatingContainerState(true));
        //     } else {
        //         dispatch(setFloatingContainerState(true));
        //     }
        // }

        const operationResponse = await operationHour();
        if (operationResponse.is_service === true)
            dispatch(setFloatingContainerState(true));
    }, []);

    return (
        <>
            <FloatingActionTrigger />
            <FloatingWindow />
        </>
    );
}
